import wixData from 'wix-data';
import wixLocation from 'wix-location';
import { session } from 'wix-storage';

$w.onReady(async function () {
  const slug = wixLocation.path[wixLocation.path.length - 1];

  const result = await wixData.query("Class Viewer")
    .eq("title", slug)
    .find();

  const item = result.items[0];

  if (!item || !item.dayOfTheWeek || !item.startTime || !item.durationMinutes || !item.url) {
    $w("#messageText").text = "Class Information Is Incomplete. Please Contact Support.";
    $w("#messageText").show();
    return;
  }

  const today = new Date();
  const todayName = today.toLocaleString("en-US", { weekday: "long" });
  const nowMinutes = today.getHours() * 60 + today.getMinutes();

  const classDays = item.dayOfTheWeek.split(",").map(day => day.trim());
  const [startHour, startMinute] = item.startTime.split(":").map(Number);
  const classStart = startHour * 60 + startMinute;
  const classEnd = classStart + item.durationMinutes;

  const isToday = classDays.includes(todayName);
  const isDuringTime = nowMinutes >= classStart && nowMinutes < classEnd;

  if (isToday && isDuringTime) {
    $w("#videoPlayer").src = item.url;
    $w("#videoPlayer").show();

    setTimeout(() => {
      $w("#messageText").text = "🔇 Tap volume to unmute!";
      $w("#messageText").show();
    }, 500);

  } else {
    $w("#messageText").text = "This class is currently unavailable. Please come back at the scheduled time.";
    $w("#messageText").show();
  }
});